import { defineStore } from 'pinia'
import type {
  AuthLoginSuccessResponse,
  AuthRefreshSuccessResponse,
} from '../types/api'
import { AdminRole } from '@/modules/Core/constants/adminAccess'
import { canAccess as checkAccess } from '@/modules/Core/utils/authorization'

interface State {
  accessToken: string
  refreshToken: string
  role: AdminRole | null
  isAuthenticated: boolean
}

function parseRole(role: string | null | undefined): AdminRole | null {
  if (!role) {
    return null
  }

  return Object.values(AdminRole).includes(role as AdminRole)
    ? (role as AdminRole)
    : null
}

function initState() {
  return {
    accessToken: '',
    refreshToken: '',
    role: null,
    isAuthenticated: false,
  } as State
}

export const useAuthStore = defineStore('auth', {
  state: () => ({ ...initState() }),
  getters: {
    canAccess:
      (state) =>
      (allowedRoles: AdminRole[]): boolean =>
        checkAccess(state.role, allowedRoles),
  },
  actions: {
    setLoginState(data: AuthLoginSuccessResponse) {
      this.accessToken = data.accessToken
      this.refreshToken = data.refreshToken
      this.role = parseRole(data.role)
      this.isAuthenticated = true
    },
    setToken(data: AuthRefreshSuccessResponse) {
      this.accessToken = data.accessToken
      this.refreshToken = data.refreshToken

      if (data.role !== undefined) {
        this.role = parseRole(data.role)
      }
    },
    logout() {
      this.isAuthenticated = false
      this.$reset()
    },
  },
  persist: {
    storage: window.localStorage,
  },
})

export default useAuthStore
